// import React from "react";
// import "./Certifications.css";

// import { testimonialsData } from "../../data/testimonials.data";
// import AnimatedHeadings from "../animatedHeadings/AnimatedHeadings";

// // Swiper
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination } from "swiper";
// import "swiper/css";
// import "swiper/css/pagination";

// const Certifications = () => {
//   return (
//     <section id="certifications">
//       <AnimatedHeadings
//         smallTitle="My Achievements"
//         mainTitle="Certifications"
//       />

//       <Swiper
//         // install Swiper modules
//         modules={[Pagination]}
//         spaceBetween={30}
//         slidesPerView={1}
//         loop={true}
//         pagination={{ clickable: true }}
//         className="container certifications__container"
//       >
//         {testimonialsData.map((testimonial, i) => (
//           <SwiperSlide key={i} className="certification">
//             <div className="certification__badge">
//               <img src={testimonial.avatar} alt="Avatar One" />
//             </div>
//             <h5 className="certification__name">{testimonial.name}</h5>
//             <small className="certification__description">
//               {testimonial.review}
//             </small>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </section>
//   );
// };

// export default Certifications;

import React from "react";
import "./Certifications.css";

import { certificationsData } from "../../data/certifications.data";
import AnimatedHeadings from "../animatedHeadings/AnimatedHeadings";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const Certifications = () => {
  return (
    <section id="certifications">
      <AnimatedHeadings smallTitle="My Achievements" mainTitle="Certifications" />

      <Swiper
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        pagination={{ clickable: true }}
        className="container certifications__container"
      >
        {certificationsData.map((cert, i) => (
          <SwiperSlide key={cert.id} className="certification">
            <div className="certification__badge">
              <img src={cert.badge} alt={`${cert.name} Badge`} />
            </div>
            <h5 className="certification__name">{cert.name}</h5>
            <small className="certification__description">{cert.description}</small>
            {cert.credentialUrl && (
              <a
                href={cert.credentialUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="certification__link"
              >
                View Certificate
              </a>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Certifications;
